import React from 'react'
import Footer from '../components/Footer';
import '../css/Obrigado.css'

const Obrigado = () => {

    return (

        <div className='thanks-container'>
            <div className='thanks-card'>
                <h1>
                    Parabéns!
                </h1>
                <h2>Você deu um passo importante na sua carreira!</h2>
                <h3>Obrigado por me permitir participar dessa transformação. </h3>
                <img className='photo-thanks' src="ok.jpg" alt="produtor" />
                <div className='text-thanks'>
                    <p className='thanks-text'>Enviei um email pra você com todas as informações que precisa para acessar seu curso.</p>
                    <p>se tiver algum problema pode me chamar em <strong>ulissesrce@gmail.com</strong>, que te ajudo</p>
                    <p>Forte abraço e bons estudos!</p>
                </div>
            </div>
            <Footer />
        </div>
    )

};
export default Obrigado;
